module.exports = __webpack_public_path__ + "static/media/icon4.f0764686.png";